import { each, $1 } from '../util'

/**
 * @module PathwaysSelector
 */
const PathwaysSelector = (() => {

  const selectorsValues = {}

  const _switchSpan = (online, offline) => {
    const onlineSpan = online.querySelector('span')
    const offlineSpan = offline.querySelector('span')
    
    if (onlineSpan.innerText != '') {
      offlineSpan.innerText = onlineSpan.innerText
      onlineSpan.innerText = ''
    } else {
      onlineSpan.innerText = offlineSpan.innerText
      offlineSpan.innerText = ''
    }
  }

  const _updateInputCourses = (input) => {
    input.value = JSON.stringify(selectorsValues)
  }

  const manageSelector = (selector) => {
    const inputCourses = selector.querySelector('.js-pathway-selector-courses')

    const courseSelectorsOnlineRequired = selector.querySelectorAll('.js-pathway-selector-course-selector-online-required')
    each(courseSelectorsOnlineRequired, (_i, courseSelectorOnlineRequired) => {
      const uuid = courseSelectorOnlineRequired.getAttribute('data-value')
      selectorsValues[uuid] = 'online'
    })

    const courseSelectorsOfflineRequired = selector.querySelectorAll('.js-pathway-selector-course-selector-offline-required')
    each(courseSelectorsOfflineRequired, (_i, courseSelectorOfflineRequired) => {
      const uuid = courseSelectorOfflineRequired.getAttribute('data-value')
      selectorsValues[uuid] = 'offline'
    })

    const courseSelectorsOnline = selector.querySelectorAll('.js-pathway-selector-course-selector-online')
    each(courseSelectorsOnline, (_i, courseSelectorOnline) => {
      const uuid = courseSelectorOnline.getAttribute('data-value')
      selectorsValues[uuid] = 'online'

      courseSelectorOnline.addEventListener('click', (e) => {
        e.preventDefault()
        selectorsValues[uuid] = 'online'

        const offlineVersion = selector.querySelector(`.js-pathway-selector-course-selector-offline[data-value="${uuid}"]`)
        if (courseSelectorOnline.classList.contains('c-button--main')) {
          courseSelectorOnline.classList.remove('c-button--main')
          courseSelectorOnline.classList.add('c-button--success')
          offlineVersion.classList.add('c-button--main')
          offlineVersion.classList.remove('c-button--success')
          _switchSpan(courseSelectorOnline, offlineVersion)
          _updateInputCourses(inputCourses)
        }
        // else {
        //   courseSelectorOnline.classList.add('c-button--main')
        //   offlineVersion.classList.remove('c-button--main')
        // } 
      })
    })

    const courseSelectorsOffline = selector.querySelectorAll('.js-pathway-selector-course-selector-offline')
    each(courseSelectorsOffline, (_i, courseSelectorOffline) => {
      const uuid = courseSelectorOffline.getAttribute('data-value')

      courseSelectorOffline.addEventListener('click', (e) => {
        e.preventDefault()
        selectorsValues[uuid] = 'offline'

        const onlineVersion = selector.querySelector(`.js-pathway-selector-course-selector-online[data-value="${uuid}"]`)
        if (courseSelectorOffline.classList.contains('c-button--main')) {
          courseSelectorOffline.classList.remove('c-button--main')
          courseSelectorOffline.classList.add('c-button--success')
          onlineVersion.classList.add('c-button--main')
          onlineVersion.classList.remove('c-button--success')
          _switchSpan(onlineVersion, courseSelectorOffline)
          _updateInputCourses(inputCourses)
        }
        // else {
        //   courseSelectorOffline.classList.add('c-button--main')
        //   onlineVersion.classList.remove('c-button--main')
        // }
      })
    })

    _updateInputCourses(inputCourses)
  }

  const init = () => {
    const selector = $1('.js-pathway-selector')
    if (!selector) return

    manageSelector(selector) 
  }

  return {
    init
  }
})()

export default PathwaysSelector


// WEBPACK FOOTER //
// app/javascript/scripts/components/PathwaysSelector.js